import {POST} from "@/services/gateway";

const listSnapshotDetails = ({userIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('google/contact/search', {userIds, folderId, snapshotDateTime, pagination, searchTerm})
}

const listBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('google/contact/breadcrumbs', {userId, folderId, snapshotDate})
}


export {
  listSnapshotDetails,
  listBreadcrumps
}
